{
	"App Settings": {
		"adminLoginPageContent": {
			"permission": "Admin",
			"translations": {},
			"type": "TextArea",
			"value": "## Welcome to the Admin Portal\n\nThis is your digital cockpit — where mere mortals become web legends.\n\nFrom here, you can manage site content, send out envelopes (without the postage), assign roles (cue the dramatic music), and publish updates like the digital overlord you were always meant to be.\n\nWhether you're tweaking a headline, uploading a banner, or granting someone the sacred power of \"Admin Access,\" this is your command center.\n\nLog in below to get started. Just don’t forget your coffee — great things are ahead. ☕"
		},
		"aiFormClassificationInstructions": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"Contact Us": {
					"translations": {},
					"value": "You classify inbound website form submissions for a law firm. If the submission has message content, determine if the submission is relevant or pertains to a legal matter or if it is spam/unrelated. Submissions without message content should not be marked as spam/unrelated. Always respond using the provided JSON schema."
				}
			}
		},
		"buildVersion": {
			"permission": "Admin",
			"type": "TextInput",
			"value": "29"
		},
		"callrailScriptSrcx": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "//cdn.callrail.com/companies/601170138/2226bc895382cc4176de/12/swap.js - not sure if I should use this yet."
		},
		"defaultFormLayouts": {
			"permission": "Admin",
			"translations": {},
			"type": "TextArea",
			"value": "calls.0.fieldOrder.0.fieldName: Caller\ncalls.0.fieldOrder.1.fieldName: Caller Name\ncalls.0.fieldOrder.2.fieldName: Call\ncalls.0.fieldOrder.3.fieldName: Start Time\ncalls.0.groupClass: md:grid md:grid-cols-2\ncalls.0.id: 2c3d5eff-4bb0-4272-b3b9-3ce07f32247d\ncalls.0.label: Call Information\ncases.0.fieldOrder.0.fieldName: Case Name\ncases.0.fieldOrder.1.fieldName: Primary Contact Phone\ncases.0.fieldOrder.2.fieldName: Revenue Value\ncases.0.fieldOrder.3.fieldName: Primary Attribution\ncases.0.fieldOrder.4.fieldName: First Call\ncases.0.groupClass: md:grid md:grid-cols-2\ncases.0.id: d0ae2ed2-23dc-4a2a-b8b7-72c78a3e093d\ncases.0.label: Case Information\ncases.1.fieldOrder.0.fieldName: Calls\ncases.1.groupClass: md:grid md:grid-cols-2\ncases.1.id: efd372ee-5c4d-4ee8-923e-5c8fb19677c4\ncases.1.label: All Calls\ncontacts.0.fieldOrder.0.fieldName: Contact Name\ncontacts.0.fieldOrder.1.fieldName: Last Call\ncontacts.0.fieldOrder.2.fieldName: First Name\ncontacts.0.fieldOrder.3.fieldName: Roles\ncontacts.0.fieldOrder.4.fieldName: Last Name\ncontacts.0.fieldOrder.5.fieldName: Relationships\ncontacts.0.groupClass: md:grid md:grid-cols-2\ncontacts.0.id: 11677afc-cfe2-4774-8c76-533949c46c5e\ncontacts.0.label: Contact Information"
		},
		"defaultTableLayouts": {
			"permission": "Admin",
			"type": "TextArea",
			"value": "submissions.columnOrder.0: Submission Id\nsubmissions.columnOrder.1: Submitted"
		},
		"formBanner": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {},
					"value": ""
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/tj-moore.firebasestorage.app/o/uploads%2Fsettings%2FApp%20Settings%2FformBanner%2Fform-banner.png?alt=media&token=b2165da0-c48b-4ca1-90ca-ce1cb16fb944",
				"formattedSize": "9.32 KB",
				"height": 634,
				"name": "form-banner.png",
				"path": "uploads/settings/App Settings/formBanner/form-banner.png",
				"size": 9547,
				"type": "image/png",
				"updated": "2026-04-06T08:56:48.043Z",
				"width": 2294
			}
		},
		"index": 0,
		"initialAdminInitialized": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "true"
		},
		"labels": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"address": {
					"translations": {},
					"value": "Address+:+"
				},
				"appUpdateMessage": {
					"translations": {},
					"value": "A new version of the app is available. Please reload to get the latest features."
				},
				"email": {
					"translations": {},
					"value": "Email+:+"
				},
				"hours": {
					"translations": {},
					"value": "Hours+:+"
				},
				"inPerson": {
					"translations": {},
					"value": "In Person+:+"
				},
				"phone": {
					"translations": {},
					"value": "Phone+:+"
				},
				"ratingCountLabel": {
					"translations": {},
					"value": "Total Reviews"
				},
				"relatedArticles": {
					"translations": {},
					"value": "Related Articles"
				},
				"reviewAction": {
					"translations": {},
					"value": "Leave a Review"
				},
				"statTitle": {
					"translations": {},
					"value": "Average User Rating"
				},
				"tableOfContents": {
					"translations": {},
					"value": "Table of Contents"
				},
				"video": {
					"translations": {},
					"value": "Video+:+"
				}
			}
		},
		"lightThemeOverwrites": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"0": {
					"translations": {},
					"value": "color-base-100: oklch(0% 0 0)\n--color-base-200: oklch(19% 0 0)\n--color-base-300: oklch(22% 0 0)\n--color-base-content: oklch(87.609% 0 0)\n--color-primary: #b09403\n--color-primary-content: oklch(12% 0.042 264.695)\n--color-secondary: oklch(35% 0 0)\n--color-secondary-content: oklch(100% 0 0)\n--color-accent: oklch(35% 0 0)\n--color-accent-content: oklch(100% 0 0)\n--color-neutral: oklch(35% 0 0)\n--color-neutral-content: oklch(100% 0 0)\n--color-info: oklch(45.201% 0.313 264.052)\n--color-info-content: oklch(89.04% 0.062 264.052)\n--color-success: oklch(51.975% 0.176 142.495)\n--color-success-content: oklch(90.395% 0.035 142.495)\n--color-warning: oklch(96.798% 0.211 109.769)\n--color-warning-content: oklch(19.359% 0.042 109.769)\n--color-error: oklch(62.795% 0.257 29.233)\n--color-error-content: oklch(12.559% 0.051 29.233)\n--radius-selector: 0rem\n--radius-field: 0rem\n--radius-box: 0rem\n--size-selector: 0.25rem\n--size-field: 0.25rem\n--border: 1px\n--depth: 0\n--noise: 0"
				},
				"--border": {
					"translations": {},
					"value": "1px"
				},
				"--color-accent": {
					"translations": {},
					"value": "oklch(35% 0 0)"
				},
				"--color-accent-content": {
					"translations": {},
					"value": "oklch(100% 0 0)"
				},
				"--color-base-100": {
					"translations": {},
					"value": "oklch(0% 0 0)"
				},
				"--color-base-200": {
					"translations": {},
					"value": "oklch(19% 0 0)"
				},
				"--color-base-300": {
					"translations": {},
					"value": "oklch(22% 0 0)"
				},
				"--color-base-content": {
					"translations": {},
					"value": "oklch(87.609% 0 0)"
				},
				"--color-error": {
					"translations": {},
					"value": "oklch(62.795% 0.257 29.233)"
				},
				"--color-error-content": {
					"translations": {},
					"value": "oklch(12.559% 0.051 29.233)"
				},
				"--color-info": {
					"translations": {},
					"value": "oklch(45.201% 0.313 264.052)"
				},
				"--color-info-content": {
					"translations": {},
					"value": "oklch(89.04% 0.062 264.052)"
				},
				"--color-neutral": {
					"translations": {},
					"value": "oklch(35% 0 0)"
				},
				"--color-neutral-content": {
					"translations": {},
					"value": "oklch(100% 0 0)"
				},
				"--color-primary": {
					"translations": {},
					"value": "#b09403"
				},
				"--color-primary-content": {
					"translations": {},
					"value": "oklch(12% 0.042 264.695)"
				},
				"--color-secondary": {
					"translations": {},
					"value": "oklch(35% 0 0)"
				},
				"--color-secondary-content": {
					"translations": {},
					"value": "oklch(100% 0 0)"
				},
				"--color-success": {
					"translations": {},
					"value": "oklch(51.975% 0.176 142.495)"
				},
				"--color-success-content": {
					"translations": {},
					"value": "oklch(90.395% 0.035 142.495)"
				},
				"--color-warning": {
					"translations": {},
					"value": "oklch(96.798% 0.211 109.769)"
				},
				"--color-warning-content": {
					"translations": {},
					"value": "oklch(19.359% 0.042 109.769)"
				},
				"--depth": {
					"translations": {},
					"value": "0"
				},
				"--noise": {
					"translations": {},
					"value": "--color-base-100: oklch(0% 0 0)\n--color-base-200: oklch(19% 0 0)\n--color-base-300: oklch(22% 0 0)\n--color-base-content: oklch(87.609% 0 0)\n--color-primary: #b09403\n--color-primary-content: oklch(12% 0.042 264.695)\n--color-secondary: oklch(35% 0 0)\n--color-secondary-content: oklch(100% 0 0)\n--color-accent: oklch(35% 0 0)\n--color-accent-content: oklch(100% 0 0)\n--color-neutral: oklch(35% 0 0)\n--color-neutral-content: oklch(100% 0 0)\n--color-info: oklch(45.201% 0.313 264.052)\n--color-info-content: oklch(89.04% 0.062 264.052)\n--color-success: oklch(51.975% 0.176 142.495)\n--color-success-content: oklch(90.395% 0.035 142.495)\n--color-warning: oklch(96.798% 0.211 109.769)\n--color-warning-content: oklch(19.359% 0.042 109.769)\n--color-error: oklch(62.795% 0.257 29.233)\n--color-error-content: oklch(12.559% 0.051 29.233)\n--radius-selector: 0rem\n--radius-field: 0rem\n--radius-box: 0rem\n--size-selector: 0.25rem\n--size-field: 0.25rem\n--border: 1px\n--depth: 0\n--noise:"
				},
				"--radius-box": {
					"translations": {},
					"value": "0rem"
				},
				"--radius-field": {
					"translations": {},
					"value": "0rem"
				},
				"--radius-selector": {
					"translations": {},
					"value": "0rem"
				},
				"--size-field": {
					"translations": {},
					"value": "0.25rem"
				},
				"--size-selector": {
					"translations": {},
					"value": "0.25rem"
				}
			}
		},
		"postWebhookFunction CallRail Post-Call 01": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"functionName": {
					"translations": {},
					"value": "processCallRailWebhook"
				},
				"triggerField": {
					"translations": {},
					"value": "query.source"
				},
				"triggerValue": {
					"translations": {},
					"value": "CallRail Post-Call Webhook HOLD"
				}
			}
		},
		"postWebhookFunction CallRail Post-Call 02": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"functionName": {
					"translations": {},
					"value": "emailCallRailCallNotification"
				},
				"triggerField": {
					"translations": {},
					"value": "query.source"
				},
				"triggerValue": {
					"translations": {},
					"value": "CallRail Post-Call Webhook HOLD"
				}
			}
		},
		"postWebhookFunction CallRail Post-Call 03:": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"functionName": {
					"translations": {},
					"value": "textCallRailCallNotification"
				},
				"triggerField": {
					"translations": {},
					"value": "query.source"
				},
				"triggerValue": {
					"translations": {},
					"value": "CallRail Post-Call Webhook HOLD"
				}
			}
		},
		"roles": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"admin": {
					"translations": {},
					"value": "Administrator"
				},
				"caseManagement": {
					"translations": {},
					"value": "Case Management"
				},
				"submissions": {
					"translations": {},
					"value": "Submissions"
				}
			}
		},
		"tfSubmissions": {
			"permission": "Admin",
			"translations": {},
			"type": "TextArea"
		},
		"themeCustomizations": {
			"permission": "Admin",
			"translations": {},
			"type": "TextArea",
			"value": "p {\n\t@apply leading-loose;\n}\n\np + p {\n\t@apply mt-1 sm:mt-2;\n}\n\nhr {\n\t@apply mt-2 sm:mt-4;\n}\n\n.bottom-rounded-full {\n  clip-path: circle(150% at 50% -120%);\n}\n"
		}
	},
	"Footer": {
		"disclaimers": {
			"permission": "Admin",
			"translations": {
				"en-US": "Attorney Advertising. The information you obtain at this site is not, nor is it intended to be legal advice. You should consult an attorney for advice regarding your individual situation.\n\nContacting us does not create an attorney-client relationship. Please do not send any confidential information to us until such time as an attorney-client relationship has been established."
			},
			"type": "TextArea",
			"value": "Attorney Advertising. The information you obtain at this site is not, nor is it intended to be legal advice. You should consult an attorney for advice regarding your individual situation.\n\nContacting us does not create an attorney-client relationship. Please do not send any confidential information to us until such time as an attorney-client relationship has been established."
		},
		"footerReview": {
			"permission": "Admin",
			"textObject": "statTitle: Average User Rating\nratingCountLabel: Total Reviews\nreviewAction: Leave A Review",
			"translations": {},
			"type": "TextObject",
			"value": {
				"ratingCountLabel": {
					"translations": {
						"en": "Total Reviews",
						"en-US": "Total Reviews"
					},
					"value": "Total Reviews"
				},
				"reviewAction": {
					"translations": {
						"en": "Leave A Review",
						"en-US": "Leave A Review"
					},
					"value": "Leave A Review"
				},
				"statTitle": {
					"translations": {
						"en": "Average User Rating",
						"en-US": "Average User Rating"
					},
					"value": "Average User Rating"
				}
			}
		},
		"index": 1,
		"privacyPolicy": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"href": {
					"translations": {},
					"value": "/privacy-policy/"
				},
				"label": {
					"translations": {},
					"value": "Privacy Policy"
				}
			}
		},
		"termsOfService": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"href": {
					"translations": {},
					"value": "/tos/"
				},
				"label": {
					"translations": {},
					"value": "Terms Of Service"
				}
			}
		}
	},
	"Head": {
		"defaultDescription": {
			"permission": "Admin",
			"translations": {
				"en-US": "Best criminal lawyers Birmingham are at the law office of Thomas J Moore. From felony cases to DUI's for over 23yrs."
			},
			"type": "TextArea",
			"value": "Best criminal lawyers Birmingham are at the law office of Thomas J Moore. From felony cases to DUI's for over 23yrs."
		},
		"defaultIcon": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {},
					"value": "Balanced scales of justice in gold"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/tj-moore.firebasestorage.app/o/uploads%2Fsettings%2FHead%2FdefaultIcon%2Ffavicon%202.png?alt=media&token=f194657e-d9f2-449b-89fe-a4bb5bb7d688",
				"formattedSize": "12.35 KB",
				"height": 160,
				"name": "favicon 2.png",
				"path": "uploads/settings/Head/defaultIcon/favicon 2.png",
				"query": "?as=run",
				"size": 12648,
				"type": "image/png",
				"updated": "2026-04-03T02:43:14.279Z",
				"width": 214
			}
		},
		"defaultImage": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {},
					"value": "Thomas J. Moore, experienced criminal and DUI attorney serving Birmingham, Alabama, pictured with courthouse background and law office branding."
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/tj-moore.firebasestorage.app/o/uploads%2Fsettings%2FHead%2FdefaultImage%2Ftj-moore-preview.jpg?alt=media&token=5c839a5f-6416-4d4a-a40a-184caf76636f",
				"formattedSize": "131.79 KB",
				"height": 630,
				"name": "tj-moore-preview.jpg",
				"path": "uploads/settings/Head/defaultImage/tj-moore-preview.jpg",
				"query": "?as=run",
				"size": 134951,
				"type": "image/jpeg",
				"updated": "2026-04-06T03:52:00.483Z",
				"width": 1200
			}
		},
		"defaultSubTitle": {
			"permission": "Admin",
			"translations": {
				"en-US": "DUI Attorneys Alabama"
			},
			"type": "TextInput",
			"value": "DUI Attorneys Alabama"
		},
		"index": 2
	},
	"Header": {
		"Menu 01": {
			"permission": "Admin",
			"textObject": "label: Home\nhref: /",
			"translations": {},
			"type": "TextObject",
			"value": {
				"col": {
					"translations": {},
					"value": "home"
				},
				"href": {
					"translations": {
						"en": "/",
						"en-US": "/"
					},
					"value": "/"
				},
				"label": {
					"translations": {
						"en": "Home",
						"en-US": "Home"
					},
					"value": "Home"
				}
			}
		},
		"Menu 02": {
			"permission": "Admin",
			"textObject": "label: About Us\nhref: /about-us",
			"translations": {},
			"type": "TextObject",
			"value": {
				"col": {
					"translations": {},
					"value": "about us"
				},
				"href": {
					"translations": {},
					"value": "/about-us/"
				},
				"label": {
					"translations": {},
					"value": "About us"
				}
			}
		},
		"Menu 03": {
			"permission": "Admin",
			"textObject": "label: Practice Areas\nhref: /practice-areas",
			"translations": {},
			"type": "TextObject",
			"value": {
				"col": {
					"translations": {},
					"value": "practice areas"
				},
				"href": {
					"translations": {},
					"value": "/practice-areas/"
				},
				"label": {
					"translations": {},
					"value": "Practice Areas"
				}
			}
		},
		"Menu 04": {
			"permission": "Admin",
			"textObject": "label: Testimonials\nhref: /testimonials",
			"translations": {},
			"type": "TextObject",
			"value": {
				"col": {
					"translations": {},
					"value": "testimonials"
				},
				"href": {
					"translations": {},
					"value": "/testimonials/"
				},
				"label": {
					"translations": {},
					"value": "Testimonials"
				}
			}
		},
		"Menu 05": {
			"permission": "Admin",
			"textObject": "label: Location\nhref: /location",
			"translations": {},
			"type": "TextObject",
			"value": {
				"col": {
					"translations": {},
					"value": "location"
				},
				"href": {
					"translations": {},
					"value": "/location/"
				},
				"label": {
					"translations": {},
					"value": "Location"
				}
			}
		},
		"Menu 06": {
			"permission": "Admin",
			"textObject": "label: Contact Us\nhref: /contact-us",
			"translations": {},
			"type": "TextObject",
			"value": {
				"col": {
					"translations": {},
					"value": "contact us"
				},
				"href": {
					"translations": {},
					"value": "/contact-us/"
				},
				"label": {
					"translations": {},
					"value": "Contact Us"
				}
			}
		},
		"Menu 21": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"hide": {
					"translations": {},
					"value": "userRoles.admin, in, , undefined, false"
				},
				"href": {
					"translations": {},
					"value": "/admin/"
				},
				"label": {
					"translations": {},
					"value": "Admin"
				},
				"opStr": {
					"translations": {},
					"value": "src.type, ==, TextObject"
				},
				"optionHref": {
					"translations": {},
					"value": "lang, area, src.value.path.value, src.value.endpoint.value"
				},
				"optionLabel": {
					"translations": {},
					"value": "src.value.label"
				},
				"optionQuery": {
					"translations": {},
					"value": "src.value.params.value"
				},
				"options": {
					"translations": {},
					"value": "settings, adminMenus"
				}
			}
		},
		"Menu 41": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"col": {
					"translations": {},
					"value": "privacy policy"
				},
				"hide": {
					"translations": {},
					"value": "true"
				},
				"href": {
					"translations": {},
					"value": "/privacy-policy/"
				},
				"label": {
					"translations": {},
					"value": "Privacy Policy"
				}
			}
		},
		"Menu 42": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"col": {
					"translations": {},
					"value": "terms of service"
				},
				"hide": {
					"translations": {},
					"value": "true"
				},
				"href": {
					"translations": {},
					"value": "/tos/"
				},
				"label": {
					"translations": {},
					"value": "Terms of Service"
				}
			}
		},
		"banner": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"href": {
					"translations": {},
					"value": "/"
				}
			}
		},
		"bannerImageDark": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {},
					"value": "The Thomas J. Moore Law Office banner in white and gold"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/tj-moore.firebasestorage.app/o/uploads%2Fsettings%2FHeader%2FbannerImageDark%2Fbanner.png?alt=media&token=742baecb-1c4b-40f7-84ed-a894f02106cb",
				"formattedSize": "9.32 KB",
				"height": 634,
				"name": "banner.png",
				"path": "uploads/settings/Header/bannerImageDark/banner.png",
				"query": "?as=run:0",
				"size": 9547,
				"type": "image/png",
				"updated": "2026-08-09T00:39:15.772Z",
				"width": 2294
			}
		},
		"bannerImageLight": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {},
					"value": "The Thomas J. Moore Law Office banner in dark gold and gold"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/tj-moore.firebasestorage.app/o/uploads%2Fsettings%2FHeader%2FbannerImageLight%2Fbanner-light.png?alt=media&token=71c9e912-d282-45ca-bb31-0439209bb30c",
				"formattedSize": "16.64 KB",
				"height": 634,
				"name": "banner-light.png",
				"path": "uploads/settings/Header/bannerImageLight/banner-light.png",
				"query": "?as=run:0",
				"size": 17040,
				"type": "image/png",
				"updated": "2026-04-03T03:44:41.594Z",
				"width": 2294
			}
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"bannerClass": {
					"translations": {},
					"value": "cursor-pointer inline-block my-auto relative w-80"
				},
				"bannerImageClass": {
					"translations": {},
					"value": "relative"
				}
			}
		},
		"index": 3,
		"showWeather": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "false"
		}
	},
	"adminMenus": {
		"Menu 01": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {},
					"value": "Home"
				},
				"params": {
					"translations": {},
					"value": "col=home"
				},
				"path": {
					"translations": {},
					"value": "admin"
				}
			}
		},
		"Menu 02": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {},
					"value": "About Us"
				},
				"params": {
					"translations": {},
					"value": "col=about us"
				},
				"path": {
					"translations": {},
					"value": "admin"
				}
			}
		},
		"Menu 03": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {},
					"value": "Practice Areas"
				},
				"params": {
					"translations": {},
					"value": "col=practice areas"
				},
				"path": {
					"translations": {},
					"value": "admin"
				}
			}
		},
		"Menu 04": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {},
					"value": "Testimonials"
				},
				"params": {
					"translations": {},
					"value": "col=testimonials"
				},
				"path": {
					"translations": {},
					"value": "admin"
				}
			}
		},
		"Menu 05": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {},
					"value": "Location"
				},
				"params": {
					"translations": {},
					"value": "col=location"
				},
				"path": {
					"translations": {},
					"value": "admin"
				}
			}
		},
		"Menu 06": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {},
					"value": "Locations"
				},
				"params": {
					"translations": {},
					"value": "col=locations"
				},
				"path": {
					"translations": {},
					"value": "admin"
				}
			}
		},
		"Menu 07": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {},
					"value": "Contact Us"
				},
				"params": {
					"translations": {},
					"value": "col=contact us"
				},
				"path": {
					"translations": {},
					"value": "admin"
				}
			}
		},
		"Menu 08": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {},
					"value": "Privacy Policy"
				},
				"params": {
					"translations": {},
					"value": "col=privacy policy"
				},
				"path": {
					"translations": {},
					"value": "admin"
				}
			}
		},
		"Menu 09": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {},
					"value": "Terms of Service"
				},
				"params": {
					"translations": {},
					"value": "col=terms of service"
				},
				"path": {
					"translations": {},
					"value": "admin"
				}
			}
		},
		"Menu 21": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {},
					"value": "Settings"
				},
				"params": {
					"translations": {},
					"value": "col=settings"
				},
				"path": {
					"translations": {},
					"value": "admin"
				}
			}
		},
		"Menu 22": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"endpoint": {
					"translations": {},
					"value": "operations"
				},
				"label": {
					"translations": {},
					"value": "Operations"
				},
				"path": {
					"translations": {},
					"value": "admin"
				}
			}
		},
		"Menu 23": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"endpoint": {
					"translations": {},
					"value": "submissions"
				},
				"label": {
					"translations": {},
					"value": "Submissions"
				},
				"path": {
					"translations": {},
					"value": "admin"
				}
			}
		},
		"Menu 24": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"endpoint": {
					"translations": {},
					"value": "case-management"
				},
				"label": {
					"translations": {},
					"value": "Case Management"
				},
				"path": {
					"translations": {},
					"value": "admin"
				}
			}
		},
		"Menu 25": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"endpoint": {
					"translations": {},
					"value": "roles"
				},
				"label": {
					"translations": {},
					"value": "Roles"
				},
				"path": {
					"translations": {},
					"value": "admin"
				}
			}
		},
		"Menu 26": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"endpoint": {
					"translations": {},
					"value": "appsettings"
				},
				"label": {
					"translations": {},
					"value": "App Settings"
				},
				"path": {
					"translations": {},
					"value": "admin"
				}
			}
		},
		"Menu 27": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {},
					"value": "Logout"
				},
				"path": {
					"translations": {},
					"value": "admin"
				}
			}
		},
		"index": 4
	}
}